// extracted by mini-css-extract-plugin
module.exports = {"inactive_card_message":"popupDeletedUser_inactive_card_message__1UbIC","title":"popupDeletedUser_title__3KnfD","message":"popupDeletedUser_message__16OF6"};